import React from "react";
import url from "../config/Config";
import { useHistory } from "react-router-dom";

export const BarraCategoria = ({
    listaCategorias,
    categoriaActual,
    listaProductos4,
}) => {
    const history = useHistory();

    const pintarCategoriaActual = (categoria) => {
        return url.capitalizeWords(categoria) ===
            url.capitalizeWords(categoriaActual)
            ? "font-bold"
            : "font-normal text-gray-700";
    };

    const handleClickCategory = (categoria) => {
        var url =
            `/categoria/${categoria.IdCategoria}/${categoria.Nombre}/1` +
            "?e=".concat(localStorage.getItem("empresa"));
        history.push(url);
        listaProductos4(categoria.IdCategoria);
    };

    return (
        <>
            <div className="border bg-white px-2 py-3  rounded-lg">
                <h3 className="font-bold text-xl py-2 px-2">Categorías</h3>
                <ul className="list-unstyled space-y-2">
                    {listaCategorias.length > 0 &&
                        listaCategorias.map((categoria) => (
                            <li key={categoria.IdCategoria}>
                                <button
                                    style={{
                                        padding: "0",
                                        margin: "0",
                                        height: "auto",
                                    }}
                                    type="button"
                                    className={`${pintarCategoriaActual(
                                        categoria.Nombre
                                    )} flex align-items-center hover:text-tertiary-personalize hover:underline`}
                                    onClick={() =>
                                        handleClickCategory(categoria)
                                    }
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-chevron-left-icon lucide-chevron-left"
                                    >
                                        <path d="m15 18-6-6 6-6" />
                                    </svg>
                                    <span className="text-base">
                                        {url.capitalizeWords(categoria.Nombre)}
                                    </span>
                                </button>
                            </li>
                        ))}
                </ul>
            </div>
            <div className="border bg-white p-4 rounded-lg mt-2">
                <h3 className="font-bold text-xl my-2">Rango de Precios</h3>
                <div className="relative mb-6">
                    <label htmlFor="labels-range-input" className="sr-only">
                        Rango
                    </label>
                    <input
                        id="labels-range-input"
                        type="range"
                        // value="1000"
                        min="100"
                        max="1500"
                        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                        defaultValue={10}
                    />
                    <span className="text-sm text-gray-500 absolute start-0 -bottom-6">
                        100 Bs.
                    </span>
                    <span className="text-sm text-gray-500 absolute start-1/3 -translate-x-1/2 rtl:translate-x-1/2 -bottom-6">
                        500 Bs.
                    </span>
                    <span className="text-sm text-gray-500 absolute start-2/3 -translate-x-1/2 rtl:translate-x-1/2 -bottom-6">
                        1000 Bs.
                    </span>
                    <span className="text-sm text-gray-500 absolute end-0 -bottom-6">
                        1500 Bs.
                    </span>
                </div>
            </div>
        </>
    );
};
